import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Empty, Input, message, Spin, Table, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { patchPriorizarConsulta } from '../../services';
import { formatarDataCorrida } from '../../helpers/formatarDataFila';
import iconPriorizar from './Images/priorizar.svg';

const searchableText = item =>
  [item?.matriz?.nome, item?.idIntegracao, item?.cliente?.nomeFantasia]
    .filter(Boolean)
    .join(' ')
    .toLocaleLowerCase('pt-BR');

export function Solicitacoes({
  solicitacoes = [],
  spinningReqConsultation,
  listaSolicitacaoConsulta = () => {},
  canPrioritize,
}) {
  const [search, setSearch] = useState('');

  const filteredRequests = useMemo(() => {
    const term = search.trim().toLocaleLowerCase('pt-BR');
    return term
      ? solicitacoes.filter(item => searchableText(item).includes(term))
      : solicitacoes;
  }, [search, solicitacoes]);

  const prioritize = async id => {
    if (!canPrioritize) return;

    const { status, error } = await patchPriorizarConsulta(id);

    if (status === 200) {
      await listaSolicitacaoConsulta();
      return;
    }

    message.error(
      error?.response?.data?.detail || 'Erro ao tentar priorizar a solicitação.'
    );
  };

  const columns = [
    ...(canPrioritize
      ? [
          {
            title: 'Priorizar',
            key: 'priorizar',
            width: 90,
            align: 'center',
            render: (_, item) => (
              <Tooltip title="Priorizar solicitação">
                <Button
                  type="text"
                  aria-label={`Priorizar solicitação ${
                    item?.idIntegracao || ''
                  }`}
                  onClick={() => prioritize(item?.id)}
                  icon={
                    <img width="16" height="16" src={iconPriorizar} alt="" />
                  }
                />
              </Tooltip>
            ),
          },
        ]
      : []),
    {
      title: 'Solicitação',
      dataIndex: 'idIntegracao',
      key: 'idIntegracao',
      width: 150,
      render: value => <strong>{value || '-'}</strong>,
    },
    {
      title: 'Tipo',
      key: 'matriz',
      width: 160,
      render: (_, item) => item?.matriz?.nome || '-',
    },
    {
      title: 'Cliente',
      key: 'cliente',
      width: 180,
      render: (_, item) => item?.cliente?.nomeFantasia || '-',
    },
    {
      title: 'Tempo fila',
      dataIndex: 'tempoFila',
      key: 'tempoFila',
      width: 120,
      render: value => formatarDataCorrida(value) || '-',
    },
  ];

  return (
    <Spin
      spinning={spinningReqConsultation}
      size="large"
      description="Carregando Solicitações..."
    >
      <div id="solicitacoes" className="painel-list-content">
        <Input
          allowClear
          className="painel-list-search"
          onChange={event => setSearch(event.target.value)}
          value={search}
          placeholder="Busca"
          prefix={<SearchOutlined />}
        />
        <Table
          id="rows"
          size="small"
          rowKey={item => item.id || item.idIntegracao}
          columns={columns}
          dataSource={filteredRequests}
          pagination={false}
          scroll={{ x: 700, y: 360 }}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Sem solicitações"
              />
            ),
          }}
        />
      </div>
    </Spin>
  );
}

Solicitacoes.propTypes = {
  solicitacoes: PropTypes.arrayOf(PropTypes.shape({})),
  spinningReqConsultation: PropTypes.bool,
  listaSolicitacaoConsulta: PropTypes.func,
  canPrioritize: PropTypes.bool,
};

Solicitacoes.defaultProps = {
  solicitacoes: [],
  spinningReqConsultation: false,
  listaSolicitacaoConsulta: () => {},
  canPrioritize: false,
};
